<template>
  <section>
    <overlay-alert
      :show-progress="showProgress"
      :process-alert="processAlert"
    />
    <v-alert
      v-if="!permissionCheck('read-board-list') && !permissionCheck('read-group')"
      text
      prominent
      type="warning"
      color="red"
      border="left"
      class="authorization-alert"
    >
      You are not authorized to perform this action. Please contact your administrator.
    </v-alert>
    <v-card
      v-if="permissionCheck('read-board-list') || permissionCheck('read-group')"
      shaped
      color="#ECEFF1"
    >
      <br>
      <base-tree-view-without-actions
        :value="treeData"
        class="my-tree-view-style"
      >
        <span slot-scope="{node, path, tree}">
          <input
            id="myCheck"
            type="checkbox"
            :checked="node.$checked"
            @change="onCheckBoxChange(node, tree, path)"
          >
          {{ node.text }}
        </span>
      </base-tree-view-without-actions>
      <v-card-actions>
        <v-btn
          color="red darken-3"
          @click="cancel()"
        >
          cancel
        </v-btn>
        <v-spacer />
        <v-btn
          class="mt-2"
          color="#FF3700"
          :disabled="!isBoardSelected"
          @click="playYoutubeVideo()"
        >
          Create
        </v-btn>
      </v-card-actions>
      <centre-spinner
        :loading="loading"
      />
    </v-card>
  </section>
</template>
<script>
  import Constants from 'src/constants';
  import { walkTreeData } from 'he-tree-vue';
  import { getDefaultStructure, addMissingBoards } from 'src/helpers/digi-board-structure-helper';
  import global from 'src/mixins/global';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import moment from 'moment';
  import OverlayAlert from 'src/views/dashboard/component/OverlayAlert';

  export default {
    name: 'LinkDigiBoards',
    components: {
      'centre-spinner': spinner,
      'overlay-alert': OverlayAlert,
    },
    mixins: [global],
    data () {
      return {
        selectedDigiBoards: [],
        treeData: [],
        loading: false,
        showProgress: false,
        processAlert: '',
      };
    },
    computed: {
      savedStructure () {
        return this.$store.getters['grouping/getSavedStructure'];
      },
      digiBoards () {
        return this.$store.getters['digiboards/getDigiBoards'];
      },
      advancedScheduleData () {
        return this.$store.getters['schedule/getScheduleData'];
      },
      isBoardSelected () {
        if (this.selectedDigiBoards.length > 0) {
          return true;
        }
        return false;
      },
      youtubeVideoForAdding () {
        return this.$store.getters['socialmedia/getYoutubeVideoForAdding'];
      },
      addedYoutubeVideo () {
        return this.$store.getters['socialmedia/getAddedYoutubeVideo'];
      },
    },
    async mounted () {
      this.loading = true;
      this.permissionCheck('read-group') && await this.fetchDigiBoardSavedStructure();
      this.permissionCheck('read-board-list') && await this.fetchDigiBoards();
      this.showBoardTreeList();
      this.loading = false;
    },
    methods: {
      async fetchDigiBoardSavedStructure () {
        await this.$store.dispatch('grouping/fetchSavedStructure');
      },
      async fetchDigiBoards () {
        await this.$store.dispatch('digiboards/fetchDigiBoards');
      },
      showBoardTreeList () {
        if (Object.keys(this.savedStructure).length <= 0) {
          const digiBoards = this.digiBoards;
          this.treeData = getDefaultStructure(digiBoards);
          return;
        }
        const treeData = this.savedStructure.group;
        const digiBoards = this.digiBoards;
        this.treeData = addMissingBoards(treeData, digiBoards);
      },
      onCheckBoxChange (node, tree, path) {
        tree.toggleCheck(node, path);
        const selectedNodes = [];
        tree.walkTreeData((node) => {
          node.$checked && selectedNodes.push(node);
        });
        this.selectedDigiBoards = selectedNodes;
      },
      async linkDigiBoard () {
        if (this.permissionCheck('link-youtube-content-to-boards') === false) {
          this.$router.push({ name: 'Campaign List' });
          this.$store.dispatch('alert/onAlert', {
            message: 'You are not authorized to link this content with devices. Please contact your administrator.',
            type: Constants.ALERT_TYPE_INFO,
          });
          return;
        }
        this.processAlert = 'Linking...';
        const finalResult = [];
        walkTreeData(this.treeData, (node) => {
          if (node.$checked && node.id !== undefined) {
            finalResult.push(node.id);
          }
        });
        this.$store.dispatch('publish/addSelectedBoardsForPublish', finalResult);
        await this.$store.dispatch('socialmedia/linkYoutubeVideoToBoard', {
            digiBoards: {
              digi_boards: finalResult,
            },
            videoId: this.addedYoutubeVideo.id,
          });
        this.processAlert = '';
        this.showProgress = false;
        this.$store.dispatch('alert/onAlert', {
          message: 'Youtube video added successfully.',
          type: Constants.ALERT_TYPE_SUCCESS,
        });
        this.$router.push({ name: 'Social Media' });
      },
      convertToGmt (date) {
        return moment(date).utc();
      },
      cancel () {
        this.$router.push({ name: 'Social Media' });
      },
      async playYoutubeVideo () {
        this.showProgress = true;
        this.processAlert = 'Creating...';
        const schedules = [];
        for (const advancedSchedule of this.advancedScheduleData) {
          schedules.push(advancedSchedule.id);
        }
        await this.$store.dispatch('socialmedia/addYoutubeVideo', {
            title: this.youtubeVideoForAdding.videoTitle,
            url_field: this.youtubeVideoForAdding.videoUrl,
            video_type: this.youtubeVideoForAdding.videoType,
            video_start_time: this.youtubeVideoForAdding.videoStartTime,
            video_end_time: this.youtubeVideoForAdding.videoEndTime,
            video_repeat: this.youtubeVideoForAdding.repeatVideo,
            autoplay: true,
            subtitles: this.youtubeVideoForAdding.showSubtitles,
            start_date: this.convertToGmt(this.youtubeVideoForAdding.start),
            end_date: this.youtubeVideoForAdding.end !== null ? this.convertToGmt(this.youtubeVideoForAdding.end) : null,
            url_type: this.youtubeVideoForAdding.urlType,
            mute: this.youtubeVideoForAdding.mute,
            schedules: schedules,
            enablejsapi: true,
          }).then(response => {
          this.$store.dispatch('socialmedia/clearYotubeVideoForAdding');
          this.$store.dispatch('schedule/clearAdvancedSchedule');
          this.linkDigiBoard();
        }).catch(() => {
          this.$router.push({ name: 'Social Media' });
        });
      },
    },
  };
</script>
<style scoped>
.my-tree-view-style {
  margin-left: 30px;
}
.authorization-alert {
  font-family: 'Times New Roman', Times, serif;
  font-size: 16px;
}
input[type="checkbox"] {
accent-color: #FF3700
}
</style>
